import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign ResizeObserver-loop warning triggered by Leaflet so CRA's
// dev-mode red error overlay does not block the UI. The W3C spec marks this as
// non-fatal; the listener has no effect in production builds.
const RESIZE_OBSERVER_LOOP_RE = /^ResizeObserver loop/;
const isResizeObserverNoise = (msg) =>
  typeof msg === "string" && RESIZE_OBSERVER_LOOP_RE.test(msg);

window.addEventListener("error", (e) => {
  if (isResizeObserverNoise(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (isResizeObserverNoise(e.reason?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
